import * as React from 'react';
import * as Immutable from 'immutable';

import WorkingDaysSummary from './WorkingDaysSummary';
import WorkingDaysSelectorModal from './WorkingDaysSelectorModal';
import popOverFactory from 'common/components/core/popover/popOverFactory';

import { memoizedImmutable } from 'common/utils/Memoizer';

class SlotSelectionComponent extends React.Component {
    render() {
        const {
            theme,
            defaultWorkingDays,
            onClick,
            translationsObject
        } = this.props;
        return (
            <span className={theme.changeSlot} onClick={onClick}>
                {defaultWorkingDays.size > 0
                    ? translationsObject.change
                    : translationsObject.add}
            </span>
        );
    }
}

export const SlotSelectionComponentWithPopover = popOverFactory({
    Component: SlotSelectionComponent
});

class EntityWorkingDaysInput extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isWorkingDaysSelectorVisible: false
        };
    }

    onShowWorkingDaysSelector = () => {
        this.setState({ isWorkingDaysSelectorVisible: true });
    };

    onHideWorkingDaysSelector = () => {
        this.setState({ isWorkingDaysSelectorVisible: false });
    };

    handleWorkingDaysChange = workingDays => {
        const { onChange } = this.props;
        onChange && onChange(Immutable.List(workingDays));
    };

    @memoizedImmutable()
    getDefaultWorkingDays(workingDays) {
        if (workingDays) {
            return workingDays.toArray();
        } else {
            // If workingDays are not there, we dont want to show default workingDays in slot selector,
            // hence init to empty array
            return [];
        }
    }

    render() {
        const {
            workingDays,
            defaultWorkingDays,
            popOverContent,
            theme,
            translationsObject,
            testId
        } = this.props;
        const {
            startLocationPlaceholder,
            endLocationPlaceholder
        } = translationsObject;
        const { isWorkingDaysSelectorVisible } = this.state;

        return (
            <div data-test-id={testId}>
                <WorkingDaysSummary slots={workingDays} />
                <SlotSelectionComponentWithPopover
                    theme={theme}
                    translationsObject={translationsObject}
                    defaultWorkingDays={defaultWorkingDays}
                    onClick={this.onShowWorkingDaysSelector}
                    popOverContent={popOverContent}
                    isPopOverOpen={
                        !!popOverContent && !isWorkingDaysSelectorVisible
                    }
                />
                {isWorkingDaysSelectorVisible ? (
                    <WorkingDaysSelectorModal
                        startLocationPlaceholder={startLocationPlaceholder}
                        endLocationPlaceholder={endLocationPlaceholder}
                        theme={theme}
                        defaultWorkingDays={this.getDefaultWorkingDays(
                            defaultWorkingDays
                        )}
                        onDismiss={this.onHideWorkingDaysSelector}
                        onWorkingDaysApply={this.handleWorkingDaysChange}
                    />
                ) : null}
            </div>
        );
    }
}

export default EntityWorkingDaysInput;
